export const oauthApplicationsClientId = "/oauth/applications/:client_id";
